// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageUploader_root__B0WdT","imageBox":"ImageUploader_imageBox__81Zj9","remove":"ImageUploader_remove__3LHzL","upload":"ImageUploader_upload___50Wy"};